import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'frequently-questions',
  templateUrl: './frequently-questions.component.html',
  styleUrls: ['./frequently-questions.component.scss'],
})
export class FrequentlyQuestionsComponent implements OnInit {
  questions!: any[];
  @Input() data!: any;

  constructor() { }

  ngOnInit(): void {
    if (this.data) {
      this.questions = this.data;
    } else {
      this.questions = [
        { title: 'How can I save money on household bills?', body: 'Comparing all of the different suppliers can save you money on household bills. Don\'t Waste Money make that evaluation process stressfree through our team of over 400 agents who are trained to find you the best deal on your energy bills. By switching suppliers you can easily save a significant amount on your bills throughout the year.' },
        { title: 'How can I switch my energy supplier?', body: 'Switching energy suppliers is simple with Don\'t Waste Money. Once we find the right supplier for you - that not only saves you money but also ticks all the boxes in terms of contract type and billing platform - we will do the rest for you. You can sit back and relax, whilst we save you money.' },
      ];
    }
  }
}
